// extracted by mini-css-extract-plugin
export default {"button":"DiagramPosition_button__uM1+3"};